module.exports = __webpack_public_path__ + "img/logo-without-letter-o.8d5fbc8d.png";